import { render, staticRenderFns } from "./incubators.vue?vue&type=template&id=1431c820&scoped=true"
import script from "./incubators.vue?vue&type=script&lang=js"
export * from "./incubators.vue?vue&type=script&lang=js"
import style0 from "./incubators.vue?vue&type=style&index=0&id=1431c820&prod&scoped=true&lang=css"
import style1 from "./incubators.vue?vue&type=style&index=1&id=1431c820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1431c820",
  null
  
)

export default component.exports